
// Persist only this color collection's UI state; keep attribution and preview parameters.
const filterLists=['types','shades','sizes','availability'];
const filterKeys=['gender',...filterLists,'min','max','sort'];
export function readColorFilters(href) {
  const p=new URL(href).searchParams;
  const filters={gender:'all',types:[],shades:[],sizes:[],availability:[],min:'',max:'',sort:'best-selling'};
  if(['all','women','men'].includes(p.get('cc_gender'))) filters.gender=p.get('cc_gender');
  const sorts=['manual','most-relevant','best-selling','title-ascending','title-descending','price-ascending','price-descending','created-ascending','created-descending'];
  if(sorts.includes(p.get('cc_sort'))) filters.sort=p.get('cc_sort');
  for(const key of filterLists) filters[key]=[...new Set(p.getAll('cc_'+key).filter(v=>v&&v.length<=200))].slice(0,100);
  for(const key of ['min','max']) {const v=p.get('cc_'+key);if(v!==null&&v.trim()!==''&&Number.isFinite(Number(v))&&Number(v)>=0)filters[key]=v;}
  if(filters.min!==''&&filters.max!==''&&Number(filters.min)>Number(filters.max)){filters.min='';filters.max='';}
  return filters;
}
export function colorFiltersUrl(href,filters) {
  const url=new URL(href);
  for(const key of filterKeys){url.searchParams.delete('cc_'+key);const values=Array.isArray(filters[key])?filters[key]:[filters[key]];for(const value of values)if(value!==''&&value!=null)url.searchParams.append('cc_'+key,value);}
  return url.href;
}


// Move the existing inputs, preserving selections and listeners across breakpoints.
export function bindMobileFilters(root, media) {
  const dialog=root.querySelector('[data-filter-dialog]');
  if(!dialog) return;
  const trigger=root.querySelector('[data-open-filters]');
  const body=dialog.querySelector('[data-drawer-body]');
  const controls=root.querySelector('[data-filter-controls]');
  const sort=root.querySelector('.cc-sort');
  const toolbar=root.querySelector('.cc-filters-native');
  const count=toolbar.querySelector('[data-product-count]');
  const restore=()=>{ trigger.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('cc-filters-open'); };
  const sync=()=>{
    if(media.matches){ body.append(controls,sort); }
    else { if(dialog.open)dialog.close(); restore(); toolbar.insertBefore(controls,count); toolbar.insertBefore(sort,count); }
  };
  trigger.addEventListener('click',()=>{if(!media.matches)return; dialog.showModal();trigger.setAttribute('aria-expanded','true');document.documentElement.classList.add('cc-filters-open');});
  dialog.querySelectorAll('[data-close-filters]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
  dialog.addEventListener('close',restore);
  dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}});
  media.addEventListener('change',sync); sync();
}
const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
export function matchesFamily(name, family, productId) {
  const normalized = normalize(name);
  if (String(productId).endsWith('9791972147417') && normalized === 'blue grey') return family.id === 'navy';
  const allowed = new Set(family.colors.map(normalize));
  if (allowed.has(normalized)) return true;
  if (/stitch|print/i.test(normalized)) return false;
  return normalized.split('/').some(part => allowed.has(normalize(part)));
}
export function selectFamilyProducts(products, family, filters = {}) {
  const found = new Set();
  const result = [];
  for (const product of products) {
    if (found.has(product.id)) continue;
    if (filters.gender && filters.gender !== 'all' && !product.gender?.includes(filters.gender)) continue;
    if (filters.type && product.type !== filters.type) continue;
    if (filters.types?.length && !filters.types.includes(product.type)) continue;
    const choices = product.colors.filter(c => c.image && matchesFamily(c.name, family, product.id) && (!filters.shade || c.name === filters.shade) && (!filters.shades?.length || filters.shades.includes(c.name)));
    choices.sort((a,b) => Number(!!b.available) - Number(!!a.available) || Number(a.name.includes('/')) - Number(b.name.includes('/')));
    if (!choices.length) continue;
    found.add(product.id);
    const choice = choices[0];
    result.push({...product, choice, choices, multi: choice.name.includes('/') && !/stitch/i.test(choice.name)});
  }
  if (filters.sort === 'price-asc') result.sort((a,b) => a.choice.price - b.choice.price);
  if (filters.sort === 'price-desc') result.sort((a,b) => b.choice.price - a.choice.price);
  if (filters.sort === 'title') result.sort((a,b) => a.title.localeCompare(b.title));
  return result;
}
export function buildColorUrl(path, family, current) {
  const source = new URL(current);
  const url = new URL(path, source.origin);
  url.searchParams.set('view', 'cozy-colors');
  url.searchParams.set('family', family);
  if (source.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', source.searchParams.get('preview_theme_id'));
  return url.href;
}
export function orderedSwatches(colors, selected) {
  return [selected, ...colors.filter(c => c.name !== selected.name)];
}
export function responsiveProductImage(color) {
  const source = new URL(color.image.startsWith('//') ? `https:${color.image}` : color.image);
  const originalWidth = Number(color.imageWidth) || 1600;
  const max = Math.min(originalWidth,1600);
  const widths = [...new Set([360,540,720,960,1200,max].filter(width => width <= max))].sort((a,b)=>a-b);
  const atWidth = width => {const url=new URL(source);url.searchParams.set('width',String(width));return url.href;};
  return {src:atWidth(Math.min(720,max)),srcset:widths.map(width=>`${atWidth(width)} ${width}w`).join(', '),sizes:'(max-width: 640px) calc((100vw - 36px) / 2), calc((100vw - 72px) / 4)',width:originalWidth,height:Number(color.imageHeight) || Math.round(originalWidth*1.5)};
}
function setProductImage(image,color) {
  const responsive=responsiveProductImage(color);
  image.sizes=responsive.sizes;image.srcset=responsive.srcset;image.src=responsive.src;
  image.width=responsive.width;image.height=responsive.height;image.decoding='async';
}
export function buildDataUrl(path, current, filters, params = {}) {
  const source = new URL(current);
  const url = new URL(path, source.origin);
  url.searchParams.set('view','cozy-color-data');
  url.searchParams.set('sort_by',filters.sort || 'best-selling');
  if(source.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id',source.searchParams.get('preview_theme_id'));
  for(const [key,param] of [['sizes',params.size],['availability',params.availability]]) {
    if(param) for(const value of filters[key] || []) url.searchParams.append(param,value);
  }
  if(filters.min !== '' && filters.min != null) url.searchParams.set('filter.v.price.gte',filters.min);
  if(filters.max !== '' && filters.max != null) url.searchParams.set('filter.v.price.lte',filters.max);
  return url.href;
}
export async function hydrateMissingColors(products, family, lookup, readVariant) {
  const missing = products.flatMap(product => product.colors.filter(c => !c.image && matchesFamily(c.name,family,product.id)).map(color=>({product,color})));
  let index=0;
  await Promise.all(Array.from({length:3},async()=>{
    while(index<missing.length){
      const {product,color}=missing[index++];
      const id=lookup[product.id]?.[normalize(color.name)];
      if(!id) continue;
      const variant=await readVariant(product,id);
      if(String(variant.id)!==String(id)||normalize(variant.name)!==normalize(color.name)) throw new Error('Variant color mismatch');
      if(variant.image) Object.assign(color,variant,{name:color.name,variantId:String(variant.id)});
    }
  }));
}

function node(tag, className, text) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
}
function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const config = JSON.parse(root.querySelector('[data-color-config]').textContent);
  const current = new URL(location.href);
  if (config.previewTheme) current.searchParams.set('preview_theme_id', config.previewTheme);
  const destination = family => buildColorUrl(config.collectionUrl, family, current.href);
  const rail = root.querySelector('[data-color-track]');
  const collection = root.matches('[data-color-collection]');
  const requested = new URL(location.href).searchParams.get('family') || 'navy';
  const family = config.families.find(g => g.id === requested) || config.families[0];
  for (const item of config.families) {
    const link = node('a', collection ? 'cc-pill' : 'cc-tile');
    link.href = destination(item.id);
    link.setAttribute('aria-label', `Shop ${item.name}`);
    if (collection) {
      const dot = node('span', 'cc-dot'); dot.style.background = item.hex; link.append(dot, node('span', '', item.name));
      if (item.id === family.id) link.setAttribute('aria-current', 'page');
    } else {
      const image = node('img'); image.src = item.image; image.alt = `${item.name} folded scrubs and fabric`; image.loading = 'lazy'; image.width = 360; image.height = 360;
      const label = node('span', 'cc-tile-label', item.name); link.append(image, label);
    }
    rail.append(link);
  }
  for (const button of root.querySelectorAll('[data-scroll]')) {
    button.addEventListener('click', () => rail.scrollBy({left: Number(button.dataset.scroll) * Math.max(280,rail.clientWidth * .7), behavior:'smooth'}));
  }
  if (!collection) return;
  root.style.setProperty('--cc-tone', family.hex);
  root.querySelector('[data-family-title]').textContent = family.name;
  const hero = root.querySelector('[data-family-art]'); hero.src = family.hero || family.image; hero.alt = `${family.name} scrubs and fabric`;
  root.querySelector('.cc-hero').classList.toggle('cc-hero-wide', !!family.hero);
  root.querySelector('.cc-hero').classList.toggle('cc-hero-labelled', family.id === 'navy');
  document.title = `${family.name} Scrubs | COZYFIT`;
  const data = JSON.parse(root.querySelector('[data-color-products]').textContent);
  const ui = JSON.parse(root.querySelector('[data-color-ui]').textContent);
  let products = data.products;
  let allProducts = [];
  let generation = 0;
  const filters = readColorFilters(current.href);
  const persistFilters=()=>history.replaceState(history.state,'',colorFiltersUrl(location.href,filters));
  const grid = root.querySelector('[data-product-grid]');
  const count = root.querySelector('[data-product-count]');
  const status = root.querySelector('[data-color-status]');
  const controls = root.querySelector('[data-filter-controls]');
  controls.inert = true;
  const facets = data.facets || [];
  const sizeFacet = facets.find(f=>/size/i.test(f.param));
  const availabilityFacet = facets.find(f=>f.param==='filter.v.availability');
  const params = {size:sizeFacet?.param,availability:availabilityFacet?.param};
  const panels = {};
  const selectedCounts = {};
  function closePanels(except) {
    for(const detail of controls.querySelectorAll('details[open]')) if(detail!==except) detail.open=false;
  }
  document.addEventListener('click',event=>{if(!controls.contains(event.target)) closePanels();});
  controls.addEventListener('keydown',event=>{if(event.key==='Escape'){const detail=event.target.closest('details');if(detail){detail.open=false;detail.querySelector('summary').focus();}}});
  function panel(key,label,color=false) {
    const detail=node('details','cc-facet'+(color?' cc-facet-color':''));
    const summary=node('summary','',label);const mark=node('span','cc-facet-count');summary.append(mark);selectedCounts[key]=mark;
    const body=node('div','cc-facet-panel');const header=node('div','cc-facet-header');
    const selected=node('span','',ui.noneSelected);selected.dataset.selectedLabel=key;
    const reset=node('button','cc-reset',ui.reset);reset.type='button';
    reset.addEventListener('click',()=>{
      if(key==='price'){filters.min='';filters.max='';body.querySelectorAll('input').forEach(i=>i.value='');}
      else {filters[key]=[];body.querySelectorAll('input').forEach(i=>i.checked=false);}
      updateCounts();if(['sizes','availability','price'].includes(key)) loadAll();else render();
    });
    header.append(selected,reset);const choices=node('div',color?'cc-facet-options cc-color-options':'cc-facet-options');
    body.append(header,choices);detail.append(summary,body);controls.append(detail);panels[key]=choices;
    summary.addEventListener('click',()=>closePanels(detail));
    return choices;
  }
  function paintDot(dot,color) {
    if(color.swatchImage) dot.style.backgroundImage=`url("${color.swatchImage}")`;
    else if(color.swatch) dot.style.backgroundColor=color.swatch;
    else if(color.image) dot.style.backgroundImage=`url("${color.image}")`;
    else dot.classList.add('cc-dot-unknown');
  }
  function checkbox(key,value,label,color) {
    const item=node('label','cc-filter-choice');const input=node('input');input.type='checkbox';input.value=value;input.checked=filters[key].includes(value);
    input.setAttribute('aria-label',label);item.append(input);
    if(color){const dot=node('span','cc-dot');paintDot(dot,color);item.append(dot);}
    item.append(node('span','',label));
    input.addEventListener('change',()=>{
      filters[key]=Array.from(panels[key].querySelectorAll('input:checked')).map(i=>i.value);
      updateCounts();if(['sizes','availability'].includes(key)) loadAll();else render();
    });
    panels[key].append(item);
  }
  panel('availability',availabilityFacet?.label || ui.availability);
  for(const v of availabilityFacet?.values || []) checkbox('availability',v.value,v.label);
  const pricePanel=panel('price',ui.price);
  for(const [key,label] of [['min',ui.from],['max',ui.to]]) {
    const holder=node('label','cc-price-field',label);const input=node('input');input.type='number';input.min='0';input.step='0.01';input.inputMode='decimal';input.setAttribute('aria-label',label);input.value=filters[key];
    input.addEventListener('change',()=>{
      filters[key]=input.value;
      const min=filters.min===''?0:Number(filters.min),max=filters.max===''?Infinity:Number(filters.max);
      input.setCustomValidity(max<min?ui.invalidRange:'');
      if(!input.reportValidity()) return;
      pricePanel.querySelectorAll('input').forEach(i=>i.setCustomValidity(''));updateCounts();loadAll();
    });holder.append(input);pricePanel.append(holder);
  }
  panel('types',ui.productType);
  panel('sizes',sizeFacet?.label || ui.size);
  for(const v of sizeFacet?.values || []) checkbox('sizes',v.value,v.label);
  panel('shades',ui.color,true);
  function updateCounts() {
    for(const key of Object.keys(panels)) {
      const n=key==='price'?Number(filters.min!=='')+Number(filters.max!==''):filters[key].length;
      selectedCounts[key].textContent=n?` (${n})`:'';
      controls.querySelector(`[data-selected-label="${key}"]`).textContent=ui.selected.replace('[count]',n);
    }
    root.querySelector('[data-clear-all]').hidden=!['types','shades','sizes','availability'].some(k=>filters[k].length)&&filters.min===''&&filters.max==='';
  }
  function options() {
    const matching=selectFamilyProducts(allProducts,family,{gender:filters.gender});
    const types=[...new Set(matching.map(p=>p.type).filter(Boolean))].sort();
    panels.types.replaceChildren();for(const t of types) checkbox('types',t,t);
    const colors=new Map();for(const p of matching) for(const c of p.choices) if(!colors.has(c.name)) colors.set(c.name,c);
    panels.shades.replaceChildren();for(const [name,c] of [...colors].sort(([a],[b])=>a.localeCompare(b))) checkbox('shades',name,name,c);
    updateCounts();
  }
  const variantCache=new Map();
  async function readVariant(product,id) {
    const url=new URL(product.url,location.origin);url.searchParams.set('variant',id);url.searchParams.set('view','cozy-color-variant');
    if(config.previewTheme) url.searchParams.set('preview_theme_id',config.previewTheme);
    if(!variantCache.has(url.href)) variantCache.set(url.href,(async()=>{
      const response=await fetch(url,{credentials:'same-origin'});if(!response.ok) throw new Error('Variant request failed');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');return JSON.parse(doc.querySelector('[data-color-variant]').textContent);
    })());
    return variantCache.get(url.href);
  }
  function productUrl(product,color) {
    const url=new URL(product.url,location.origin);
    if(color.variantId) url.searchParams.set('variant',color.variantId);
    else if(color.optionValueId) url.searchParams.set('option_values',color.optionValueId);
    if(config.previewTheme) url.searchParams.set('preview_theme_id',config.previewTheme);
    return url.href;
  }
  function render() {
    persistFilters();
    const items=selectFamilyProducts(products,family,filters);grid.replaceChildren();
    count.textContent=(items.length===1?ui.oneProduct:ui.products).replace('[count]',items.length);
    for(const product of items) {
      let selected=product.choice;
      const card=node('article','cc-product');card.dataset.productId=product.id;
      const link=node('a','cc-product-link');link.href=productUrl(product,selected);
      const media=node('div','cc-product-media');const image=node('img');
      setProductImage(image,selected);image.alt=`${product.title} — ${selected.name}`;image.loading='lazy';media.append(image);
      if(product.sale) media.append(node('span','cc-sale',ui.sale));
      else if(product.available===false) media.append(node('span','cc-sale',ui.soldOut));
      link.append(media,node('h3','cc-product-title',product.title));card.append(link);
      const line=node('div','cc-product-meta');const price=node('div','cc-price');
      if(product.showCompare) price.append(node('s','cc-compare',product.compareText));
      price.append(node('span','',product.priceLabel || selected.priceText || ''));line.append(price);
      const swatches=node('div','cc-card-swatches');swatches.setAttribute('role','group');swatches.setAttribute('aria-label',ui.availableColors);
      const ordered=orderedSwatches(product.colors,selected);const expanded=node('div','cc-card-color-list');expanded.hidden=true;
      const cardStatus=node('span','visually-hidden');cardStatus.setAttribute('role','status');
      async function choose(color) {
        try {
          if(!color.image){
            const id=color.variantId || config.variantFallbacks?.[product.id]?.[normalize(color.name)];
            if(id){const v=await readVariant(product,id);if(normalize(v.name)!==normalize(color.name)) throw new Error('Color mismatch');Object.assign(color,v,{name:color.name,variantId:String(v.id)});}
          }
          if(!color.image){location.href=productUrl(product,color);return;}
          selected=color;setProductImage(image,color);image.alt=`${product.title} — ${color.name}`;link.href=productUrl(product,color);
          if(!Array.from(swatches.querySelectorAll('[data-swatch-name]')).some(b=>b.dataset.swatchName===color.name)) swatches.querySelector('.cc-card-swatch').replaceWith(swatch(color,false));
          for(const b of card.querySelectorAll('[data-swatch-name]')) b.setAttribute('aria-pressed',String(b.dataset.swatchName===color.name));
          expanded.hidden=true;
          const more=card.querySelector('.cc-more-colors');if(more) more.setAttribute('aria-expanded','false');
          cardStatus.textContent=color.name;
        } catch {cardStatus.textContent=ui.colorError;}
      }
      function swatch(color,labelled) {
        const button=node('button',labelled?'cc-card-color-choice':'cc-card-swatch');button.type='button';button.dataset.swatchName=color.name;button.title=color.name;
        button.setAttribute('aria-label',color.name);button.setAttribute('aria-pressed',String(color.name===selected.name));
        const dot=node('span','cc-dot');paintDot(dot,color);button.append(dot);if(labelled) button.append(node('span','',color.name));
        button.addEventListener('click',()=>choose(color));return button;
      }
      for(const color of ordered.slice(0,5)) swatches.append(swatch(color,false));
      if(ordered.length>5){
        const more=node('button','cc-more-colors',`+${ordered.length-5}`);more.type='button';more.setAttribute('aria-label',ui.allColors);more.setAttribute('aria-expanded','false');
        more.addEventListener('click',()=>{expanded.hidden=!expanded.hidden;more.setAttribute('aria-expanded',String(!expanded.hidden));});swatches.append(more);
        for(const c of ordered) expanded.append(swatch(c,true));
      }
      line.append(swatches);card.append(line,expanded,cardStatus);grid.append(card);
    }
    root.querySelector('[data-color-empty]').hidden=items.length>0;
  }
  root.querySelectorAll('[data-gender]').forEach(button=>button.addEventListener('click',()=>{
    filters.gender=button.dataset.gender;root.querySelectorAll('[data-gender]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));options();render();
  }));
  root.querySelectorAll('[data-gender]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gender===filters.gender)));
  root.querySelector('[data-color-sort]').value=filters.sort;
  root.querySelector('[data-color-sort]').addEventListener('change',event=>{filters.sort=event.target.value;loadAll();});
  function reset() {
    Object.assign(filters,{types:[],shades:[],sizes:[],availability:[],min:'',max:''});
    controls.querySelectorAll('input').forEach(input=>{if(input.type==='checkbox')input.checked=false;else input.value='';input.setCustomValidity('');});
    updateCounts();loadAll();
  }
  bindMobileFilters(root, window.matchMedia('(max-width:749px)'));
  root.querySelector('[data-drawer-reset]').addEventListener('click',reset);
  root.querySelector('[data-reset-filters]').addEventListener('click',reset);
  root.querySelector('[data-clear-all]').addEventListener('click',reset);
  async function loadAll() {
    persistFilters();
    const turn=++generation;grid.setAttribute('aria-busy','true');status.textContent=ui.loading;count.textContent='';
    try {
      let next=buildDataUrl(config.collectionUrl,current.href,filters,params);let pages=0;const seen=new Set();const loaded=[];
      while(next){
        if(++pages>40||seen.has(next)) throw new Error('Pagination could not complete');seen.add(next);
        const url=new URL(next,location.origin);url.searchParams.set('view','cozy-color-data');
        if(config.previewTheme) url.searchParams.set('preview_theme_id',config.previewTheme);
        const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Product request failed');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const page=JSON.parse(doc.querySelector('[data-color-products]').textContent);
        if(turn!==generation)return;
        loaded.push(...page.products);next=page.next;
      }
      await hydrateMissingColors(loaded,family,config.variantFallbacks||{},readVariant);
      if(turn!==generation)return;
      products=loaded;
      if(!allProducts.length) allProducts=loaded;
      controls.inert=false;status.textContent='';options();render();
    } catch {if(turn===generation){grid.replaceChildren();status.textContent=ui.error;count.textContent='';}}
    finally {if(turn===generation)grid.setAttribute('aria-busy','false');}
  }
  loadAll();
}
if (typeof document !== 'undefined') {
  const start = () => document.querySelectorAll('[data-cozy-colors]').forEach(init);
  start();document.addEventListener('shopify:section:load',start);
}
